<div class="px-3">
  <span class="display-5 title-menu text-uppercase py-3 d-flex"
    >Application</span
  >
  <div class="">
    <del-shared-menu-sidebar [isMessages]="true"></del-shared-menu-sidebar>
  </div>
</div>
